import {CartItem} from '@features/sales/domain/entities/cart/cart-item.entity';
import {CartItemDTO} from "@features/sales/domain/models/cart/cart-item.model";

export class Cart {
  private readonly items: CartItem[];

  constructor(items: CartItemDTO[]) {
    this.items = items.map((dto) => new CartItem(dto));
  }

  addItem(item: CartItem): void {
    const incoming = item.toDTO();

    const index = this.items.findIndex((existing) =>
      existing.matchesDTO(incoming),
    );

    if (index === -1) {
      this.items.push(item);

      return;
    }

    this.items[index].addQuantity(item.quantity);
  }

  get isEmpty(): boolean {
    return this.items.length === 0;
  }

  get totalPrice(): number {
    return this.items.reduce((sum, item) => sum + item.amount, 0);
  }

  toDTOs(): CartItemDTO[] {
    return this.items.map((item) => item.toDTO());
  }
}
